import * as React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useGetCclEventByEventKeyQuery } from "../../../../services/cclTokenedSessionApi";
import { DetailsTabPanel } from "../../../../components/common/detailTabPanel/detailTabPanel";
import SessionApplicationLogsCard from "./sessionApplicationLogsCard";
import SessionJournalEntryTimelineCard from "./sessionJournalEntryTimelineCard";
import SessionParticipantsJournalEntryTimelineCard from "./sessionParticipantsJournalEntryTimelineCard";

interface SessionHistoryPanelProps {
    sessionId: string;
    drawerOpen: boolean;
}

const SessionHistoryPanel: React.FC<SessionHistoryPanelProps> = (props) => {
    const [alignment, setAlignment] = React.useState<number>(0);
    const { data: sessionDetail } = useGetCclEventByEventKeyQuery(props.sessionId, {
        skip: !props.sessionId,
    });

    const handleTabChange = (event: React.SyntheticEvent, newValue: number | null) => {
        if (newValue != null) setAlignment(newValue);
    };

    // Tablist
    const tablist: [string, React.ReactNode][] = [
        [
            "Events",
            <SessionApplicationLogsCard
                sessionId={props.sessionId}
                sessionCode={sessionDetail?.sessionCode ?? ""}
            />,
        ],
        [
            "Session Journal",
            <SessionJournalEntryTimelineCard
                sessionCode={sessionDetail?.sessionCode ?? ""}
                sessionId={props.sessionId}
                drawerOpen={props.drawerOpen}
            />,
        ],
        [
            "Participants Journal",
            <SessionParticipantsJournalEntryTimelineCard
                sessionId={props.sessionId}
                sessionCode={sessionDetail?.sessionCode ?? ""}
            />,
        ],
    ];

    return (
        <Box
            sx={{
                width: 1,
                height: 1,
                m: 2,
                borderWidth: 0,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box display={"flex"} justifyContent={"center"} sx={{ borderWidth: 0, flexGrow: 1 }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleTabChange}
                    sx={{ mb: 3 }}
                >
                    {tablist.map((tab, i) => (
                        <ToggleButton key={i} id={`${props.sessionId}-history-tab-${i}`} value={i}>
                            {tab[0]}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            {tablist.map((tab, i) => (
                <DetailsTabPanel
                    detailType={props.sessionId}
                    key={tab[0]}
                    value={alignment}
                    index={i}
                >
                    {tab[1]}
                </DetailsTabPanel>
            ))}
        </Box>
    );
};

export default SessionHistoryPanel;
